/** student/skills — API. */
import { http } from '../../_shared/http';
import type { SkillDefinition } from './types';

export const studentSkillsApi = {
  list: () => http.get<SkillDefinition[]>('/skills'),
};
